var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElectricMeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 34,
    viewBox: "0 0 31 34",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 33.5832V29.4165C7.55556 28.3888 5.15278 26.5902 3.29167 24.0207C1.43056 21.4513 0.5 18.5277 0.5 15.2499C0.5 13.1665 0.895833 11.2152 1.6875 9.39571C2.47917 7.57627 3.54861 5.99293 4.89583 4.64571C6.24306 3.29849 7.82639 2.22904 9.64583 1.43738C11.4653 0.645711 13.4028 0.249878 15.4583 0.249878C17.5139 0.249878 19.4583 0.645711 21.2917 1.43738C23.125 2.22904 24.7222 3.29849 26.0833 4.64571C27.4444 5.99293 28.5208 7.57627 29.3125 9.39571C30.1042 11.2152 30.5 13.1665 30.5 15.2499C30.5 18.5277 29.5625 21.4374 27.6875 23.979C25.8125 26.5207 23.4167 28.3193 20.5 29.3749V33.5832H17.1667V30.1665C16.8889 30.2221 16.6111 30.2499 16.3333 30.2499H15.4583C15.1806 30.2499 14.9097 30.2429 14.6458 30.229C14.3819 30.2152 14.1111 30.1943 13.8333 30.1665V33.5832H10.5ZM8.83333 11.9999H22.1667V8.66654H8.83333V11.9999ZM14.25 25.3332L19.25 20.3332L17.1667 18.2499L19.25 16.1665L16.75 13.6665L11.75 18.6665L13.8333 20.7499L11.75 22.8332L14.25 25.3332Z",
    fill: "#C80000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricMeter);
export default __webpack_public_path__ + "static/media/electric_meter.cf291be2.svg";
export { ForwardRef as ReactComponent };